import React, { useState } from 'react';
import { Icon, Icons, Typography } from '@nextiva/next-ui-components';
import { newAnchorOrigin, newTransformOrigin } from '../../constants/popoverConfig';
import { StyledMenu, StyledMenuItem, StyledMenuHeader } from './SupportMenu.styled';

const iconSx = { fontSize: '12px' };
const ticketIconSx = {
  transform: 'rotate(90deg)',
};

const id = 'global-header-support';
const paperProps = { id: `${id}-menu` };

export const SupportMenu = () => {
  const [menuAnchorElement, setMenuAnchorElement] = useState(null);
  const isOpen = Boolean(menuAnchorElement);

  return (
    <>
      <StyledMenu
        open={isOpen}
        anchorEl={menuAnchorElement}
        onClose={() => setMenuAnchorElement(null)}
        anchorOrigin={newAnchorOrigin}
        transformOrigin={newTransformOrigin}
        PaperProps={paperProps}
      >
        <StyledMenuHeader id={`${id}-menu-title`} data-testid="GlobalHeader-SupportMenu-HelpSupportHeader">
          Help &amp; support
        </StyledMenuHeader>
        <StyledMenuItem
          component="a"
          id={`${id}-menu-item-report-an-issue`}
          href="https://www.nextiva.com/support/submit-a-ticket"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="GlobalHeader-SupportMenu-ReportAnIssueMenuItem"
        >
          <Icon
            icon={Icons.ticket}
            htmlColor="#758BA3"
            sx={ticketIconSx}
            data-testid="GlobalHeader-SupportMenu-TicketIcon"
          />
          <Typography variant="body2">Report an issue</Typography>
          <Icon
            icon={Icons.newWindow}
            sx={iconSx}
            htmlColor="#758BA3"
            data-testid="GlobalHeader-SupportMenu-NewWindowIcon"
          />
        </StyledMenuItem>
        <StyledMenuItem
          component="a"
          id={`${id}-menu-item-knowledge-base`}
          href="https://www.nextiva.com/support/"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="GlobalHeader-SupportMenu-KnowledgeBaseMenuItem"
        >
          <Icon icon={Icons.books} htmlColor="#758BA3" data-testid="GlobalHeader-SupportMenu-BooksIcon" />
          <Typography variant="body2">Knowledge base</Typography>
          <Icon
            icon={Icons.newWindow}
            sx={iconSx}
            htmlColor="#758BA3"
            data-testid="GlobalHeader-SupportMenu-NewWindowIcon"
          />
        </StyledMenuItem>
        <StyledMenuItem
          component="a"
          id={`${id}-menu-item-contact-us`}
          href="https://www.nextiva.com/company/contact.html"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="GlobalHeader-SupportMenu-ContactUsMenuItem"
        >
          <Icon icon={Icons.headset} htmlColor="#758BA3" data-testid="GlobalHeader-SupportMenu-HeadsetIcon" />
          <Typography variant="body2">Contact us</Typography>
          <Icon
            icon={Icons.newWindow}
            sx={iconSx}
            htmlColor="#758BA3"
            data-testid="GlobalHeader-SupportMenu-NewWindowIcon"
          />
        </StyledMenuItem>
      </StyledMenu>
    </>
  );
};

SupportMenu.displayName = 'SupportMenu';
